import React from "react";
import {
  AccessTime,
  InfoOutlined,
  Inventory2Outlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useWarehousingDetailContext } from "contexts/WarehousingDetailContext";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import { localizeDateTimeShort } from "utils/dateFormats";

const WarehousingBasicDetail = () => {
  const { warehousingDetail, loadingWarehousing } =
    useWarehousingDetailContext();

  return !loadingWarehousing ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Inventory2Outlined color="primary" />}
            title="Warehousing ID"
            subtitle={warehousingDetail?.warehousingId || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Name"
            subtitle={warehousingDetail?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <Inventory2Outlined color="primary" />}
            title="Warehouse"
            subtitle={
              warehousingDetail?.warehouseId &&
              typeof warehousingDetail.warehouseId === "object" ? (
                <OpenInNewTab
                  label={`${
                    warehousingDetail.warehouseId.warehouse_id ?? ""
                  } - ${warehousingDetail.warehouseId.name ?? ""}`}
                  link={`/app/crm/warehouse/${warehousingDetail.warehouseId._id}/detail`}
                />
              ) : (
                "N/A"
              )
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Created Time"
            subtitle={localizeDateTimeShort(warehousingDetail?.createdAt)}
          />
        </Grid>
         <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created By"
            subtitle={warehousingDetail?.createdBy?.name	 || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Is Active ?"
          >
            <Status isActive={warehousingDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default WarehousingBasicDetail;
